import { useState, ReactNode } from 'react';

import ResponsiveSearchDrawerItem, {
  ResponsiveDrawerInterface,
} from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveDrawer from '@components/views/components/listing/drawer/ResponsiveDrawer';

import { ResponsivePickerContentMobile } from './ResponsiveSearchInputDrawerStyle';

type Props = Omit<ResponsiveDrawerInterface, 'onClick'> & {
  drawerTitle?: string;
  children: (child: () => void) => ReactNode;
  booker?: boolean;
};

const ResponsiveSearchInputDrawer = ({
  children,
  drawerTitle,
  booker,
  ...otherProps
}: Props) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const hideModal = () => {
    setIsShowModal(false);
  };

  return (
    <>
      {isShowModal ? (
        <ResponsiveDrawer
          title={drawerTitle}
          visible={isShowModal}
          onClose={hideModal}
          booker={booker}
        >
          <ResponsivePickerContentMobile>
            {children && children(hideModal)}
          </ResponsivePickerContentMobile>
        </ResponsiveDrawer>
      ) : null}
      <ResponsiveSearchDrawerItem
        {...otherProps}
        onClick={() => setIsShowModal(true)}
      />
    </>
  );
};

export default ResponsiveSearchInputDrawer;
